import gql from 'graphql-tag'

export const doesControllerExists = gql`
  query doesControllerExists($controller: NonEmptyString!) {
    doesControllerExists(controller: $controller)
  }
`
